const formatToCurrency = (v: number | string): string =>
  new Intl.NumberFormat('en-US', { style: 'currency', currency: 'ILS', minimumFractionDigits: 0 }).format(
    Number(v)
  )

const formatFromCurrency = (v: string): number => Number(v.replace(',', '').replace('₪', ''))

export { formatToCurrency, formatFromCurrency }
